module.exports = __webpack_public_path__ + "static/media/app-preview-03.9217884d.png";